import profiles from "./companyProfiles.json";

export type CompanyProfile = { name: string; url: string };

/**
 * RunMark's official third-party profiles. The data lives in
 * companyProfiles.json (not here) because public/index.html also reads it at
 * build time for the Organization JSON-LD `sameAs` -- add a profile there
 * and both the footer's "Find us on" row and the structured data pick it up.
 * Only add a profile once its page is publicly live.
 */
export const COMPANY_PROFILES: CompanyProfile[] = profiles;
